import store from '@/store'
export const getPromptOfVerifyCode = function (mobile, email) {
  const { lang } = store.state.app
  const messageMap = {
    'zh-CN': `<p style="display: inline-block;line-height: 24px;text-align:left;">验证码已经发送到<br>1. 尾号${mobile}的手机<br>2. ${email}的邮箱</p>`,
    en: `<p style="display: inline-block;line-height: 24px;text-align:left;">verification code already sent to<br>1. Phone:${mobile}<br>2. Email:${email}</p>`
  }
  return messageMap[lang]
}
